import month01 from "../imagens/aniversarios/Marco.jpg";
import month02 from "../imagens/aniversarios/Abril.jpg";
import month03 from "../imagens/aniversarios/Maio.jpg";
import month04 from "../imagens/aniversarios/Junho.jpg";
import month05 from "../imagens/aniversarios/Julho.jpg";
import month06 from "../imagens/aniversarios/Agosto.jpg";
import month07 from "../imagens/aniversarios/Julho.jpg";
import month08 from "../imagens/aniversarios/Abril.jpg";
import month09 from "../imagens/aniversarios/Abril.jpg";
import month10 from "../imagens/aniversarios/Abril.jpg";
import month11 from "../imagens/aniversarios/Abril.jpg";
import month12 from "../imagens/aniversarios/Abril.jpg";
import { Calendar } from "lucide-react";

const months = [
  { name: "Março", image: month01 },
  { name: "Abril", image: month02 },
  { name: "Maio", image: month03 },
  { name: "Junho", image: month04 },
  { name: "Julho", image: month05 },
  { name: "Agosto", image: month06 },
  // { name: "Julho", image: month07 },
  // { name: "Agosto", image: month08 },
  // { name: "Setembro", image: month09 },
  // { name: "Outubro", image: month10 },
  // { name: "Novembro", image: month11 },
  // { name: "Dezembro", image: month12 },
];

const PhotoGallery = () => {
  return (
    <section className="min-h-screen bg-background py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-in">
          <div className="flex justify-center mb-4">
            <Calendar className="w-10 h-10 text-primary" />
          </div>
          <h2 className="font-romantic text-5xl md:text-6xl text-foreground mb-4">
            Nosso Ano em Fotos
          </h2>
          <p className="font-serif text-xl text-muted-foreground">
            Doze meses, infinitas memórias
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {months.map((month, index) => (
            <div
              key={month.name}
              className="group animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 border-4 border-white">
                <img
                  src={month.image}
                  alt={`Recordação de ${month.name}`}
                  className="w-full relative max-h-[90vh] object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <h3 className="font-romantic text-2xl text-white">
                    {month.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhotoGallery;
